import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-tip2",
  "use": "icon-tip2-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" class=\"design-iconfont\" id=\"icon-tip2\">\n  <g fill=\"none\" fill-rule=\"evenodd\">\n    <path stroke=\"#E8AB79\" d=\"M10 0.5A9.5 9.5 0 1 0 10 19.5A9.5 9.5 0 1 0 10 0.5Z\" />\n    <path fill=\"#E8AB79\" d=\"M9 8H11V15H9z\" />\n    <path fill=\"#E8AB79\" d=\"M9 5H11V7H9z\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol